<template>

    <div>

        <v-layout row wrap justify-center>

            <v-flex md9 xs9 offset-md-1 offset-xs-1>

                <v-layout class="noselect tile-group" justify-center row wrap>

                    <BnTile v-for="(tile, index) in tilesAttrs"
                            :label="tile.label"
                            :icon="tile.icon"
                            :id="index"
                            :key="index"
                            :disabled="!tile.editable || !editable"
                            :selected="selected[index]"
                            @click.native="select(index, !tile.editable || !editable)"
                            :value="value"
                            v-on="$listeners"
                            v-bind="$attrs"
                            :check="checks"
                    />

                    <v-flex md1 xs1 class="aling-center">

                        <BnCustomHelp :name="mezo" :active="help"/>

                    </v-flex>

                </v-layout>

            </v-flex>

        </v-layout>

    </div>

</template>
<script>
import Vue from 'vue';
import BnCustomHelp from './BnCustomHelp.vue';

export default {
    components: { BnCustomHelp },
    props: {
        multiple: {
            default: false,
            type: Boolean,
        },
        asarray: {
            type: Boolean,
            default: false,
        },
        tilesAttrs: {
            default: Array,
            type: Array,
        },
        value: {
            type: Array,
            required: true,
        },
        checks: {
            default: false,
        },
        mezo: {
            type: String,
            default: '',
        },
        help: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        if (this.value && !!this.value.indexOf) {
            this.tilesAttrs.forEach((elem, index) => {
                if (this.value.indexOf(elem.value) > -1) {
                    Vue.set(this.selected, index, true);
                }
            });
        }
    },
    watch: {
        value(val) {
            this.update(val, val.length > 1);
        },
    },
    methods: {
        update(valueToSet, multiple = false) {
            this.tilesAttrs.forEach((tile, index) => {
                if (typeof valueToSet === 'object') {
                    valueToSet.forEach((value) => {
                        if (tile.value === value) {
                            Vue.set(this.selected, index, true);
                        } else if (!multiple) {
                            Vue.set(this.selected, index, false);
                        }
                    });
                }
            });
        },

        select(index, disabled = false) {
            if (!disabled) {
                if ((!this.selected[index] || this.multiple) && this.tilesAttrs[index].editable) {
                    Vue.set(this.selected, index, !this.selected[index]);
                    if (!this.multiple) {
                        Object.keys(this.selected).forEach((idx) => {
                            if (+idx !== +index) {
                                Vue.set(this.selected, idx, false);
                            }
                        });
                    } else {
                        /// throw new NotImplementedException()
                    }

                    if (this.multiple || this.asarray) {
                        /* if(this.selectedValues.indexOf(this.tilesAttrs[index].value) > -1) {
                                this.selectedValues =
                                this.selectedValues.slice(this.selectedValues.indexOf(this.tilesAttrs[index].value), 1)
                            } else {
                                this.selectedValues.push(this.tilesAttrs[index].value)
                                this.selectedValues = [...new Set(this.selectedValues)]
                            } */

                        this.selectedValues = [];
                        Object.keys(this.selected).forEach((item) => {
                            if (this.selected[item]) {
                                this.selectedValues.push(this.tilesAttrs[item].value);
                                this.selectedValues = [...new Set(this.selectedValues)];
                            }
                        });
                        // console.log(this.selectedValues)

                        this.$emit('input', this.selectedValues);
                        this.$emit('change', this.selectedValues);

                        // console.log(this.selectedValues)
                    } else {
                        this.$emit('input', this.tilesAttrs[index].value);
                        this.$emit('change', this.tilesAttrs[index].value);
                    }
                }
            }
        },
    },
    data() {
        return {
            selected: {},
            selectedValues: [],
        };
    },
};
</script>

<style scoped>
    .tile-group {
    }

    .aling-center {
        align-self: center;
    }
</style>
